export default "__VITE_ASSET__DTBYc7rX__"